import { Component } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Router } from '@angular/router';
import { take } from 'rxjs/operators';

import { AuthenticationService } from '../../services/authentication.service';
import { firstAllowedRoute } from '../../guards/route-roles';
import { LoginAction } from './login-card/login-action.model';

@Component({
  selector: 'app-login',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
})
export class LoginPageComponent {
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private auth: AngularFireAuth
  ) {}

  async login({ username, password }: LoginAction): Promise<void> {
    try{
      (await this.authenticationService
        .login(username, password))
        .pipe(take(1))
        .subscribe(async (user) => {
          console.log(user);
          
          if (user == null) {
            return;
          }
          await this.getInfoUser();
        });
    } catch(error) {
      console.log(error);
    }
  }

  getInfoUser() {
    this.auth.authState.subscribe(async (authUser) => {
      console.log(authUser);
      
      if (authUser) {
        const userInfo = await authUser.getIdTokenResult();
        console.log(userInfo);
        // Hạ cánh ở trang ĐẦU TIÊN vị trí này mở được, không mặc định về
        // Dashboard nữa: '/fox-admin' chính là Dashboard, mà vị trí như Nhân
        // viên không có quyền xem nó → RoleGuard chặn rồi đẩy ngược ra trang
        // đăng nhập, khoá luôn người dùng ở ngoài.
        this.router.navigate([firstAllowedRoute() || '/fox-admin']);
        // if (userInfo.claims.role) {
        //   let userNameDisplay = userInfo.claims.displayName;

        //   localStorage.setItem('userNameDisplay', userNameDisplay);
        //   localStorage.setItem('userName', userInfo.claims.displayName);
        //   localStorage.setItem('currentUser', JSON.stringify(userInfo.claims));
        //   localStorage.setItem('role', userInfo.claims.role);
        //   console.log(userInfo.claims.role);
        //   if(userInfo.claims.role === '3') {
        //     this.router.navigate(['events']);
        //   } else {
        //     this.router.navigate(['']);
        //   }
        // } else {
        //   this.router.navigate(['login']);
        // }
      } else {
        this.router.navigate(['/fox-admin/login']);
      }
    });
  }
}
